import { useGlobal } from '@/utils/useGlobal';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from 'elem/compPage/delta-3-max-plus-portable-power-station/config/pageConfig';
import { useProductDispatch } from '../../ProductStationProvider';
import styles from './index.module.scss';
import { LangText } from './LangText';
export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const router = useRouter();
    const { locale = 'us', pathname } = router;
    const { isMobile } = useGlobal();
    const TextA = LangText[locale] || LangText['us'];

    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const dispatch = useProductDispatch();

    const currentQueryString = router.asPath.includes('?') ? router.asPath.split('?')[1] : '';

    const buildUrlWithQuery = (basePath: string) => {
        return currentQueryString ? decodeURIComponent(`${basePath}?${currentQueryString}`) : basePath;
    };

    const buyMap = {
        us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station',
        ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station',
        eu: `https://eu.ecoflow.com/cart/51787034558807:1?channel=buy_button`,
        uk: `https://uk.ecoflow.com/cart/51787034558807:1?channel=buy_button`,
        de: `https://de.ecoflow.com/cart/57020101296509:1?channel=buy_button`,
        fr: `https://fr.ecoflow.com/cart/51408465002843:1?channel=buy_button`,
        es: `https://es.ecoflow.com/cart/51408468836699:1?channel=buy_button`,
        it: `https://it.ecoflow.com/cart/55289474253176:1?channel=buy_button`,
    };
    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
                // href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : buildUrlWithQuery(thePageUrl),
            },
            ...[
                ['us', 'ca'].includes(locale)
                    ? {
                          value: 'Bundles',
                          label: 'Bundles',
                      }
                    : {
                          value: 'Compare',
                          label: TextA.tab_compare,
                          href: buildUrlWithQuery(`${thePageUrl}#d3m-comparison`),
                      },
            ],
            {
                value: 'Specs',
                label: TextA.tab_specs,
                // 加上当前的查询参数
                href: buildUrlWithQuery(`${thePageUrl}/specs`),
            },
            ...(['us', 'ca'].includes(locale)
                ? [
                      {
                          value: 'Compatibility',
                          label: 'Compatibility',
                          href: buildUrlWithQuery(`${thePageUrl}/compatibility`),
                      },
                  ]
                : []),
            {
                value: 'Support',
                label: TextA.tab_support,
                href: buildUrlWithQuery(`${thePageUrl}/support`),
            },

            // {
            //     value: 'Media',
            //     label: TextA.tab_media,
            //     href: `${thePageUrl}/media`,
            // },
        ],
        buyItems: [
            {
                value: 'Buy',
                label: TextA.btn_buy,
                href: buyMap[locale as keyof typeof buyMap],
                // href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
            },
        ],
        theme: 'black',
    };
    const tabChange = (item: any, index: number) => {
        if (item.value === 'Product' && activeTab === 'Compare') {
            // 顶部
            window.scrollTo({
                left: 0,
                top: 0,
                behavior: 'smooth',
            });

            // 去掉 #hash
            window.location.hash = '';
        }
        dispatch({
            type: 'changeProductTabActive',
            payload: item.value,
        });

        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const handleBuyChange = (item: any, index: number) => {
        // dispatch({
        //     type: 'changeProductTabActive',
        //     payload: item.value,
        // });
        // if (tabCallback) {
        //     tabCallback('Bundles');
        // }
    };

    return <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={handleBuyChange} theme={'black'} />;
}
